import React from "react";
import Tooltip from '@mui/material/Tooltip';
import ClickAwayListener from '@mui/material/ClickAwayListener';

import "./mgs-tooltip-style.scss";

import Button from "@src/componentsNew/Buttons/Button";
import Typography from "@src/componentsNew/Typography/Typography";
import InfoIcon from "@src/componentsNew/Icons/Icons/InfoIcon";

import { product_product, product_product_variants } from "@components/ProductPage/ProductDetailPage/__generated__/product";


interface IProps {
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
}

const MgsTooltip = ({ open, onOpen, onClose }: IProps) => {
  const text = "MGS detail as per Govt Of India regulations will need to be provided to our courier partner. You will receive the KYC link directly from the courier partner.";

  return (
    <ClickAwayListener onClickAway={onClose}>
      <div>
        <Tooltip
          id="mobile-mgs-tooltip"
          PopperProps={{
            disablePortal: true,
          }}
          onClose={onClose}
          open={open}
          title={
            <div className="mgs-tooltip">
              <Typography variant="caption" component="p">
                {text}
              </Typography>

              <Button
                size="small"
                onClick={
                  () => window.open("https://maccaron.in/en/page/mgs_kyc_guideline/", "_blank")
                }>
                MGS Guideline
              </Button>
            </div>
          }
          placement="top"
          disableFocusListener
          disableHoverListener
          disableTouchListener>
          <div className="mgs-tooltip-trigger">
            <InfoIcon onClick={onOpen} />
          </div>
        </Tooltip>
      </div>
    </ClickAwayListener>
  )
}

export default MgsTooltip;
